import React, { useState, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'ui-components/components/button';
import PropTypes from 'prop-types';
import { deletePresetGroup } from '../../../../store/products/products.api';
import DeletePresetGroupModal from '../delete-preset-group-modal';
import messages from '../messages';

export const DeleteButton = ({ presetGroupId, needsReload, setNeedsReload }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const openDeleteModal = () => setIsModalOpen(true);
  const closeDeleteModal = () => setIsModalOpen(false);
  const onDelete = useCallback(() => {
    const deleteReportingCategoryPromise = deletePresetGroup(presetGroupId);
    deleteReportingCategoryPromise.promise.then(() => {
      setIsModalOpen(false);
      setNeedsReload(!needsReload);
    });
    return () => deleteReportingCategoryPromise?.cancel();
  }, [presetGroupId, needsReload, setNeedsReload]);

  return (
    <>
      <Button onClick={openDeleteModal} theme='link'>
        <FormattedMessage {...messages.deletePresetGroupButton} />
      </Button>
      {isModalOpen && <DeletePresetGroupModal onClose={closeDeleteModal} onDelete={onDelete} />}
    </>
  );
};

DeleteButton.propTypes = {
  presetGroupId: PropTypes.string.isRequired,
  needsReload: PropTypes.bool.isRequired,
  setNeedsReload: PropTypes.func.isRequired,
};
